import React from 'react';
import { motion } from 'framer-motion';
import { MicIcon, PlayIcon } from 'lucide-react';
import { Button } from './Button';
export function PodcastSection() {
  const episodes = [{
    title: 'The Discipline Equation',
    duration: '42 min'
  }, {
    title: 'From Zero to Leader in 18 Months',
    duration: '38 min'
  }, {
    title: 'Why Pressure Creates Diamonds',
    duration: '45 min'
  }];
  return <section id="podcast" className="py-32 px-6 bg-[var(--forge-black)] relative overflow-hidden" data-id="element-98">
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-[var(--forge-lava)] opacity-5 blur-[120px] rounded-full" data-id="element-99" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-100">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-102">
            <div className="flex items-center gap-3 mb-6" data-id="element-103">
              <MicIcon className="w-8 h-8 text-[var(--forge-lava)]" data-id="element-104" />
              <span className="text-sm font-bold tracking-wider text-[var(--forge-gray)]" data-id="element-105">
                PODCAST
              </span>
            </div>

            <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-6" data-id="element-106">
              THE FORGE{' '}
              <span className="text-[var(--forge-lava)]" data-id="element-107">TRANSMISSION</span>
            </h2>

            <p className="text-xl text-[var(--forge-gray)] mb-8 leading-relaxed" data-id="element-108">
              Your roadmap to performance, discipline, and leadership.
            </p>

            <Button size="lg" data-id="element-109">LISTEN NOW</Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-4" data-id="element-110">
            {episodes.map((episode, index) => <motion.div key={episode.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[var(--forge-charcoal)] border border-[var(--forge-steel)] p-6 flex items-center gap-4 group cursor-pointer hover:border-[var(--forge-lava)]/50 transition-all" data-id="element-111">
                <div className="flex-shrink-0 w-12 h-12 bg-[var(--forge-lava)] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-112">
                  <PlayIcon className="w-6 h-6 text-white fill-white" data-id="element-113" />
                </div>
                <div className="flex-1" data-id="element-114">
                  <h3 className="font-bold text-lg mb-1" data-id="element-115">{episode.title}</h3>
                  <p className="text-sm text-[var(--forge-gray)]" data-id="element-116">
                    {episode.duration}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}